export default __webpack_public_path__ + "static/media/151-turned-off.cacb94c0.png";